import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { Button } from 'shared/ui/button'

import s from './styles.module.scss'

interface Props {
  onClose: () => void
}

export const LimitExceededPopup: FC<Props> = ({ onClose }) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <div className={s.text}>
        <p className={clsx(s.title, 'bold-20')}>
          {t('mplus.mplus_not_avalible_info_title')}
        </p>

        <p className={clsx(s.description, 'regular-14')}>
          {t('mplus.mplus_not_avalible_info_desc')}
        </p>
      </div>

      <div className={s.buttonWrapper}>
        <Button
          className={s.button}
          onClick={onClose}
        >
          <span className="semi-bold-17">{t('ok')}</span>
        </Button>
      </div>
    </div>
  )
}
